export default {
      id: "floor-usage",
      viewBox: "0 0 12 24",
      url: __webpack_public_path__ + "icons/symbols.67516b0a.svg#floor",
      toString: function () {
        return this.url;
      }
    }